module.exports = {
  pageHeader: {
    addSimCard: 'Add Simcards',
    imeiNumber: 'IMEI Number',
    registerSale: 'Register Sale',
    newPayment: 'New Payment',
    prodcuts: 'Products',
    simcards: 'Simcards',
    closeShift: 'Close Shift',
    customer: 'Customer',
    newCustomer: 'New Customer',
    newPayee: 'New Payee',
    expense: 'Expense',
    location: 'Location',
    product: 'Product',
    inviteStore: 'Invite Store',
    inviteUser: 'Invite User',
    pointReport:'Point Report',
    category: 'Category',
    vendors: 'Vendors',
    payee: 'Payee',
    openShift: 'Open Shift',
    updateVendor: 'Update Vendor',
    cashDrawer: 'Cash Drawers',
    purchaseNumber: 'Purchase#',
    purchase: 'Purchase',
    activationSimCard: 'Activate Sim Card',
    simSwap: 'Sim Swap',
    changeNumber: 'Number Change',
    newVendor: 'New Vendor',
    masterAgent: 'Master Agent',
    catalog: 'Catalog',
    employee: 'Employee',
    newProduct: 'New Product',
    locations: 'Locations'
  },
  header: {
    notifications: 'Notifications',
    recoverPassword: 'Recover Password',
    invite: 'Invite',
    subscriberInformation: 'Subscriber Information',
    adding: 'Adding: {0}'
  },
  subTital: {
    simInformation: 'Sim Information',
    personalDetail: 'Personal Detail',
    onlyIcellutionsCardCanBeActivationOnThisPortal: 'Only iCellutions card can be actvation on this protal',
    pinSetup: 'Pin Setup',
    selectNumber: 'Selecte Number',
    finishActvation: 'Finish Actvation',
    finish: 'Finish'
  },
  navBar: {
    myProfile: 'My Profile',
    viewProfile: 'View Profile',
    closeShift: 'Close Shift',
    openShift: 'Open Shift',
    logout: 'Logout'
  },
  toastMessage: { //this.$t('toastMessage.heading.product'),
    heading: {
      invite: 'Invite Sent',
      inventory: 'Inventory',
      invoice: 'Invoice',
      vendor: 'Create Vendor',
      product: 'Product',
      updateVendor: 'Update Vendor'
    },
    text: {
      purchaseCancled: 'Purchase Was Created',
      invoiceIsCreated: 'Invoice is created',
      vendorCreated: 'Vendor Created',
      vendorUpdated: 'Vendor was updated!',
      productCreated: 'Product was created'
    }
  },
  messages: {
    title: {
      delete: 'Delete!',
      cancelled: 'Cancelled!',
      success: 'Success!',
      vendor: 'Vendor',
      areYouSure: 'Are you sure?',
      integration: 'Integration',
      addPayment: 'Add Payment',
      codeNotFound: 'Code Not Found'
    },
    text: {
      pleaseCheckTheCodeAndTryAgain: 'Please check the location code and try again.',
      enterValidAmount: 'Enter valid amount.',
      requestAccepted: 'Request was accepted!',
      enterYouEmailAddress: 'Enter your Email and instructions will be sent to you!',
      taxIsStillHere: 'Tax is still here :)',
      categoryIsStillHere: 'Category is still here :)',
      paymentStillOnDone: 'Payment still on done :)',
      paymentStillOnPending: 'Payment still on pending :)',
      youWantToDeleteThisTax: 'You want to delete this tax',
      youWantToContinueWithOutSelectingPlan: 'You want to continue without selecting plan!',
      youWantToDeleteThisCategory: 'You want to delete this category',
      youWantToMoveToPending: 'You want to move it to pending',
      youLikeToDeleteThisPurchase: 'You want to delete this purchase.',
      youWantToCancelThisSale: 'You want to cancel this sale.',
      youLikeToDeleteThisPayee: 'You like to delete this payee.',
      selectedRowIsDeleted: 'Selected row is deleted.',
      youWontBeAbleToRevertThis: "You won't be able to revert this!",
      unableToDeletePayee: 'Unable to delete payee :(',
      hasBeenDeleted: '{0} has been deleted.',
      youLikeToDeleteItem: 'You want to delete, {0}.',
      vendorNotSelected: 'Please select valid vendor before saving purchase',
      serialNumberAlreadyExist: 'Serial number already exist in this list',
      serialNumberAlreadyExistInThisOrder: 'Serial number already exist in this order',
      serialNumberYouHadPuchaseBefore: 'Serial number you had puchase before',
      youHaveDeleted: 'You have deleted',
      unableToDeletePurchase: 'Unable to delete purchase.'
    }
  },
  dataTable: {
    fromDate: 'From Date',
    toDate: 'To Date',
    runReport: 'Run Report',
    looksLikeThereIsNoData: "Looks like there's no data",
    trySelectingDifferentTimePeriod: 'Try selecting different time period.',
    action: 'Actoin',
    show: 'Show',
    entries: 'entries',
    showing: 'Showing',
    pageShowingDetail: 'Showing {0} to {1} of {2} entries',
    previous: 'Previous',
    next: 'Next',
    search: 'Search'
  },
  validations: {
    fieldIsRequired: 'Field is required',
    mustBeNumeric: 'Must be numeric.',
    mustBeMoreThen: 'Must be morethen',
    simNumberLimit: 'Sim number must have atleast {0} numbers.',
    productNameLimit: 'Product name must have atleast {0} letters.',
    pinNumberMustHaveAtLeast: 'Pin number must have at least {0} number.',
    pinNumberCantHaveMoreThen: "Pin number can't have more then {0} number.",
    pinNumberMustBeIdentical: 'Pin number must be identical.',
    youMustSelectOneNumber: 'You must select one number.',
    validEmailAddress: 'Enter valid email address',
    priceHaveToBeNumber: 'Accepts positive and negative decimal numbers.',
    mustBeSelectOne: 'Must be select one.'
  },
  labels: {
    walcome: 'Walcome',
    wantToJoinExisting: 'Want to join existing an Organization? Request the admin of that Organization to add you to their user list.',
    terminalcode: 'Terminal Code',
    source: 'Source',
    to: 'To',
    count: 'Count',
    points: 'Points',
    event: 'Event',
    saleCount: 'Sale Count',
    searchBusiness: 'Search Business',
    businessName: 'Business Name',
    averagePoint: 'Average Point',
    selectOne: 'Select One',
    wallet: 'Wallet',
    activation: 'Activation',
    walletBalance: 'Wallet Balance',
    wantToLogin: 'Want to login?',
    newSimNumber: 'New Sim Number',
    conformPinNumber: 'Conform Pin Number',
    pinNumber: 'Pin Number',
    subscribers: 'Subscribers',
    subscriber: 'Subscriber',
    optional: '(optional)',
    simNumber: 'Sim Number',
    refernceNumber: 'Reference Number',
    dontHaveAccount: "Don't have an account?",
    date: 'Date',
    subtotal: 'Sub - Total',
    unitCost: 'Unit Cost',
    purchaseID: 'Purchase ID',
    vendorName: 'Vendor Name',
    imeiNumber: 'IMEI Number',
    category: 'Category',
    defaultOpenCash: 'Default Open Cash',
    since: 'Since',
    customerSince: 'Customer Since',
    maxAmount: 'Max Amount',
    purchase: 'Purchase',
    amountDue: 'Amount Due',
    runningShift: 'Running Shift',
    availableDrawers: 'Available Drawers',
    payeeName: 'Payee Name',
    categoryName: 'Category Name',
    selectOne: 'Select One',
    selectPayee: 'Selecte Payee',
    totalCashCount: 'Total Cash Count',
    initialBalance: 'Initial Balance',
    reOrderPoint: 'Re-Order Point',
    reOrderAmount: 'Re-Order Amount',
    selectTax: 'Select Tax',
    selectedTax: 'Selected Tax',
    selectCategory: 'Selecte Category',
    refernceNumber: 'Refernce #',
    mustBeMoreThen: 'Must be morethen',
    readyToSale: 'Ready to sale',
    additional: 'Additional',
    purchaseCost: 'Purchase Cost',
    newPayee: 'New Payee',
    description: 'Description',
    brandName: 'Brand Name',
    enterPhoneNumberOrKeytag: 'Enter Phone Number or Keytag',
    selectCarrier: 'Select Carrier',
    pinNumber: 'Pin Number',
    selectProvider: 'Select Provider',
    note: 'Note',
    dueAmount: 'Due Amount',
    productImage: 'Product Image',
    autoApply: 'Auto Apply',
    value: 'Value',
    openShift: 'Open Shift',
    closeShift: 'Close Shift',
    closedShift: 'Closed Shift',
    searchProduct: 'Search Product',
    productName: 'Product Name',
    quantity: 'Quantity',
    amount: 'Amount',
    price: 'Price',
    discount: 'Discount',
    total: 'Total',
    customer: 'Customer',
    tax: 'Tax',
    name: 'Name',
    phone: 'Phone',
    spending: 'Spending',
    notTracked: 'Not Tracked',
    subTotal: 'Sub-total',
    createdAt: 'Created At',
    carrier: 'Carrier',
    provider: 'Provider',
    firstName: 'First Name',
    lastName: 'Last Name',
    phoneNumber: 'Phone Number',
    email: 'Email',
    emailAddress: 'Email Address',
    accountNumber: 'Account Number',
    website: 'Website',
    address: 'Address',
    signIn: 'Sign In',
    rememberMe: 'Remember me',
    city: 'City',
    forgotPassword: 'Forgot pwd?',
    state: 'State',
    zipCode: 'Zip Code',
    customerName: 'Customer Name',
    casherName: 'Casher Name',
    openAt: 'Open At',
    openBy: 'Open By',
    openingAmount: 'Opening Amount',
    closedAt: 'Closed At',
    closedBy: 'Closed By',
    leavingCash: 'Leaving Cash',
    totalSale: 'Total Sale',
    cashSale: 'Cash Sale',
    cashCount: 'Cash Count',
    masterCategory: 'Master Category',
    categories: 'Categories',
    fee: 'Fee',
    employee: 'Employee',
    confirmation: 'Confirmation',
    invoiceNumber: 'Invoice #',
    grandTotal: 'Grand Total',
    upcCode: 'UPC Code',
    skuCode: 'SKU Code',
    brand: 'Brand',
    stock: 'Stock'
  },
  tab: {
    pending: 'Pending',
    done: 'Done',
    cellSmart: 'CellSmart',
    onHold: 'On Hold',
    general: 'General',
    additional: 'Additional',
    tax: 'Tax',
    billPayment: 'Bill Payment',
    wallet: 'Wallet'
  },
  placeHolder: {
    addANoteToThisTransaction: 'Add a note to this transaction',
    searchFor: 'Search for...',
    addANoteToThisPurchase: 'Add a note to this purchase',
    emailAddress: 'Email Address'
  },
  sideBar: {
    simCards: 'Sim Cards',
    phoneNumber: 'Phone Number',
    inviteUser: 'Invite User',
    inviteStore: 'Invite Store',
    employee: 'Employee',
    masterAgent: 'Master Agent',
    masterAgentMenu: 'Master Agent - Menu',
    terminalMenu: 'Terminal - Menu',
    activeStore: 'Active Store',
    hyperLink: 'Hyperlink USA',
    catalog: 'Catalog',
    locations: 'Locations',
    icellutions: 'iCellutions',
    simSwap: 'Sim Swap',
    activationSim: 'Activate Sim',
    changeNumber: 'Change Number',
    mvnoMenu: 'MVNO - MENU',
    menu: 'menu',
    dashboard: 'Dashboard',
    register: 'Register',
    payment: 'Payment',
    paymentList: 'Payment List',
    newPayment: 'New Payment',
    history: 'History',
    manages: 'Manages',
    inventory: 'Inventory',
    reportCenter: 'Report Center',
    adminTools: 'Admin Tools',
    reviewInvoice: 'Review Invoice',
    reviewShift: 'Review Shift',
    product: 'Product',
    vendor: 'Vendor',
    customer: 'Customer',
    category: 'Category',
    payee: 'Payee',
    expense: 'Expense',
    purchase: 'Purchase',
    tax: 'Tax',
    expenseCategory: 'Expense Category',
    cashDrawers: 'Cash Drawers',
    settings: 'Settings',
    setting: 'Setting'
  },
  checkBox: {
    readyToSale: 'Ready to sale'
  },
  buttons: {
    revokeInvitation: 'Revoke Invitation',
    resendInvitation: 'Resend Invitaion',
    inviteStore: 'Invite Store',
    createNewOrg: 'Create New Organization',
    submitSimCard: 'Submit {0} Simcards',
    change: 'Change',
    newProduct: 'New Product',
    newSimcard: 'New Simcard',
    addToList: 'Add To List',
    openTerminal: 'Open Terminal',
    add: 'Add',
    newLocation: 'New Location',
    accept: 'Accept',
    newEmployee: 'New Employee',
    newCustomer: 'New Customer',
    newVendor: 'New Vendor',
    reject: 'Reject',
    newAgent: 'New Agent',
    yesMarkPending: 'Yes, Mark pending!',
    yesDoIt: 'Yes, do it!',
    open: 'Open',
    save: 'Save',
    reset: 'Reset',
    cancel: 'Cancel',
    close: 'Close',
    submit: 'Submit',
    pay: 'Pay',
    view: 'View',
    delete: 'Delete',
    edit: 'Edit',
    addToCart: 'Add to cart',
    newPayee: 'New Payee',
    newCategory: 'New Category',
    newPayment: 'New Payment',
    yesDeleteIt: 'Yes, delete it!',
    yesCancelIt: 'Yes! Cancel it',
    markDone: 'Mark it done',
    putOnHold: 'Put on hold',
    markPedning: 'Mark pending',
    addNew: 'Add New',
    login: 'Log In',
    signUp: 'Sign Up',
    generate: 'Generate',
    update: 'Update',
    no: 'No',
    print: 'Print',
    saveChange: 'Save Change',
    closeShift: 'Clsoe Shift'
  }
}



//////////////////
// WEBPACK FOOTER
// ../Lang/lang/english.js
// module id = xXim
// module chunks = 17